import { retrieveJsonRequest } from "./utils";

export function getListOfLayouts() {
    return retrieveJsonRequest(
        `/core/v1/sites/${window.REBELMOUSE_BOOTSTRAP_DATA.runner.id}/layouts/editor`
    );
}

export function getLayout(layoutName) {
    return retrieveJsonRequest(
        `/core/v1/sites/${window.REBELMOUSE_BOOTSTRAP_DATA.runner.id}/layouts/${layoutName}`
    );
}
